export enum AuthenticationRegistrationSource {
    work = 'selfService',
}
